import { useEffect, useState } from "react";
import api from "@/lib/api";

// Textos editables desde Panel → Contenido → "Textos de la web".
// Si un texto no está guardado en la DB, se usa el default de acá.
export const UI_DEFAULTS = {
  hero_eyebrow: "Digital Fashion Exhibition · Edición numerada",
  hero_cta: "Explorar la exhibición",
  pieces_count: "PIEZAS EN LA EXHIBICIÓN",
  early_title: "Acceso anticipado · solo para anotadas",
  early_text: "Elegí tu pieza, tocá «Quiero esta pieza» y te avisamos antes que a nadie cuando se abra la venta.",
  want_button: "QUIERO ESTA PIEZA",
  want_hint: "Próximamente · las anotadas la compran antes que el resto",
  card_badge: "próximamente",
  card_cta: "ANOTATE PARA ACCESO ANTICIPADO →",
  counter_zero: "SÉ LA PRIMERA EN ANOTARTE",
  archivo_eyebrow: "Digital fashion exhibition",
  archivo_title: "Exhibición",
  piece_info_text: "Cada unidad va a llevar un código único permanente. Cuando la edición se abra, quien la consiga recibe su ficha digital y su número de ejemplar.",
  footer_tagline: "Construí tu propio archivo.",
  footer_about: "No creamos prendas para llenar tu closet. Creamos piezas para que se queden.",
  footer_copyright: "© {año} Archive Lab · Buenos Aires",
  footer_credit: "Diseños de autor · Cami Guerra",
  hero_cta_venta: "Explorar el archivo",
  concept_eyebrow: "El concepto",
  concept_title: "Un museo de piezas de archivo",
  manifesto_script: "Una pieza puede cambiarlo todo.",
  latest_eyebrow: "Última liberación",
  latest_title: "Piezas en el archivo",
  latest_link: "Ver todo",
  mix_script: "La contradicción es parte de la identidad.",
};

export const UI_FIELDS = [
  ["hero_eyebrow", "Inicio · texto arriba del título del hero"],
  ["hero_cta", "Inicio · texto del botón para ir a la exhibición"],
  ["pieces_count", "Inicio · leyenda junto al botón (aparece con la cantidad delante)"],
  ["early_title", "Inicio · título del bloque rojo de acceso anticipado"],
  ["early_text", "Inicio · explicación del bloque rojo", true],
  ["card_badge", "Catálogo · cartelito rojo en cada prenda"],
  ["card_cta", "Catálogo · llamada bajo el nombre de la prenda"],
  ["want_button", "Prenda · texto del botón de interés"],
  ["want_hint", "Prenda · aclaración bajo el botón"],
  ["counter_zero", "Prenda · texto del contador cuando nadie se anotó"],
  ["archivo_eyebrow", "Catálogo · texto arriba del título"],
  ["archivo_title", "Catálogo · título de la página en exhibición"],
  ["piece_info_text", "Prenda · texto de la garantía (código único)", true],
  ["footer_tagline", "Pie de página · frase en letra manuscrita"],
  ["footer_about", "Pie de página · texto «No creamos prendas para llenar tu closet…»", true],
  ["footer_copyright", "Pie de página · línea de copyright (usá {año} para el año)"],
  ["footer_credit", "Pie de página · línea «Diseños de autor · Cami Guerra»"],
  ["hero_cta_venta", "Inicio (con venta abierta) · texto del botón principal"],
  ["concept_eyebrow", "Inicio (con venta abierta) · etiqueta del manifiesto"],
  ["concept_title", "Inicio (con venta abierta) · título del manifiesto"],
  ["manifesto_script", "Inicio (con venta abierta) · frase manuscrita del manifiesto", true],
  ["latest_eyebrow", "Inicio (con venta abierta) · etiqueta de últimas piezas"],
  ["latest_title", "Inicio (con venta abierta) · título de últimas piezas"],
  ["latest_link", "Inicio (con venta abierta) · enlace «Ver todo»"],
  ["mix_script", "Inicio (con venta abierta) · frase manuscrita de mezclas", true],
];

let _cache = null;
let _promise = null;

export default function useUiTexts() {
  const [t, setT] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    if (!_promise) _promise = api.get("/content/ui").then((r) => { _cache = r.data || {}; return _cache; }).catch(() => ({ ...UI_DEFAULTS }));
    _promise.then((d) => setT(d)).catch(() => {});
  }, []);
  return { ...UI_DEFAULTS, ...(t || {}) };
}

export const uiText = (t, key) => (t && t[key]) || UI_DEFAULTS[key] || "";
